
import "/home/runner/work/legacy-av-bms-crm-web-v2-reactjs/legacy-av-bms-crm-web-v2-reactjs/src/components/RightContent/index.less?modules";
export default {"account": `account-B9uCI-rQ`,"search": `search-skoHwvD7`,"avatar": `avatar-zS02O1Ex`,"dark": `dark-CHs0M1tl`,"menu": `menu-xLqIG_O9`,"right": `right-Wpkmgzqs`,"action": `action-bcpUa7hV`,"name": `name-eyow1a-1`}
